export default {
      id: "icon-icmaCentre-logo-usage",
      viewBox: "0 0 155.208 36.638",
      url: __webpack_public_path__ + "img/icons.c4ffcc33.svg#icon-icmaCentre-logo",
      toString: function () {
        return this.url;
      }
    }